var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDjango(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6672 5H22.6234V27.7112C20.5078 28.1455 18.3544 28.3695 16.1947 28.38C10.1422 28.3737 6.99219 25.67 6.99219 20.4775C6.99219 15.4775 10.3334 12.2275 15.5122 12.2275C16.2385 12.2133 16.9634 12.2974 17.6672 12.4775V5ZM17.6672 16.4275C17.1284 16.2498 16.5632 16.1652 15.9959 16.1775C13.4959 16.1775 12.0422 17.7062 12.0422 20.385C12.0422 22.9937 13.4259 24.4338 15.9647 24.4338C16.5345 24.4336 17.1035 24.3918 17.6672 24.3087V16.4337V16.4275Z",
    fill: "#44B78B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5005 12.5742V23.9492C30.5005 27.8655 30.2067 29.748 29.3467 31.3717C28.469 33.0227 27.0338 34.3086 25.2967 35.0005L20.6992 32.8342C22.3695 32.2623 23.7684 31.0914 24.6255 29.548C25.333 28.1467 25.5567 26.523 25.5567 22.2517V12.5742H30.5005Z",
    fill: "#44B78B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5058 5.02344H25.5508V10.0584H30.5058V5.02344Z",
    fill: "#44B78B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/django.7b2c5d78cfa742aaa1e22fb7b3e4c26d.svg";
export { ForwardRef as ReactComponent };